import ManualDetectedTaskButton from './ManualDetectedTaskButton';
const MarketplaceButton = ManualDetectedTaskButton;
export default MarketplaceButton;